@if (UserModuleAccess==='Full') {
<form class="row g-3" [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
	<div class="row mb-2">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('name')}" id="name"
					formControlName="name" placeholder="">
				<label for="name">Template Name</label>
			</div>
			@if (showError('name')) {
			<p class="text-danger">
				@if (f.name.errors?.required) {
				<span>
					Required
				</span>
				}
				@if (f.name.errors?.incorrect) {
				<span>
					{{customError.name}}
				</span>
				}
			</p>
			}
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<div class="text_editor_container">
				<quill-editor formControlName="body" [modules]="quillConfig" placeholder="Body"></quill-editor>
			</div>
			@if (showError('body')) {
			<p class="text-danger">
				@if (f.body.errors?.required) {
				<span>
					Required
				</span>
				}
				@if (f.body.errors?.incorrect) {
				<span>
					{{customError.body}}
				</span>
				}
			</p>
			}
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="submit" class="btn btn-sm btn-primary me-1">
				@if (showLoader) {
				<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				}@else {
				<fa-icon [icon]="['fas', 'save']"></fa-icon>
				}
				Submit
			</button>
			<button type="button" class="btn btn-sm btn-secondary" (click)="clearForm();">
				Cancel
			</button>
		</div>
	</div>
</form>
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}